import { render, staticRenderFns } from "./StreamChat.vue?vue&type=template&id=074acb1e&scoped=true&"
import script from "./StreamChat.vue?vue&type=script&lang=ts&"
export * from "./StreamChat.vue?vue&type=script&lang=ts&"
import style0 from "./StreamChat.vue?vue&type=style&index=0&id=074acb1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074acb1e",
  null
  
)

export default component.exports